import React from "react";
export default function AiInsights() {
  return (
    <>
      <section className="ai-insights-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <img src="/assets/images/ai-insight-img.webp" className="insight-graph" alt="graph" />
            </div>

            <div className="col-lg-4 col-md-5">
              <div className="ai-insights-content">
                <span>Turn Docs into Insights</span>
                <p>Built-in intelligence helps you move beyond storage and into decision-making.</p>
                <ul>
                  <li>
                    <img src="/assets/images/ai-insight-icon1.webp" alt="insight-icon" />
                    Advanced analytics for document trends
                  </li>

                  <li>
                    <img src="/assets/images/ai-insight-icon2.webp" alt="insight-icon" />
                    Real-time operational visibility
                  </li>

                  <li>
                    <img src="/assets/images/ai-insight-icon3.webp" alt="insight-icon" />
                    Compliance monitoring and audit readiness
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}